import { render } from "./TheKhachSan.vue?vue&type=template&id=018e48ad"
import script from "./TheKhachSan.vue?vue&type=script&lang=js"
export * from "./TheKhachSan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__